module.exports = __webpack_public_path__ + "img/bg.40e00ead.png";